'use strict';

var STUB_TEMPLATE = '<div></div>';

var RouteConfig = /*@ngInject*/ function (
  $stateProvider,
  $urlRouterProvider,
  $locationProvider,
  USER_ROLES
) {
  var stubAuthorizedRoles = {
    [USER_ROLES.digiTech]: {},
    [USER_ROLES.merchOps]: {},
    [USER_ROLES.photographer]: {},
    [USER_ROLES.seniorImageEditor]: {},
    [USER_ROLES.imageEditor]: {},
    [USER_ROLES.studioStylist]: {},
    [USER_ROLES.superUser]: {},
    [USER_ROLES.artBuyer]: {},
    [USER_ROLES.studioOps]: {},
    [USER_ROLES.qaReviewer]: {},
    [USER_ROLES.productReviewer]: {},
  };

  $locationProvider.hashPrefix('');
  $urlRouterProvider.otherwise('search');
  $urlRouterProvider.deferIntercept();

  $stateProvider
    .state('redirect-to-react', {
      url: '/redirect-to-react?target&q&section&productIdentifier&jobId&tab&from&autoRedirect',
      pageTitle: 'Redirecting',
      templateUrl: 'templates/views/redirectToReact.view.html',
      controller: 'RedirectToReactController',
      controllerAs: '$ctrl',
      data: {
        authorizedRoles: stubAuthorizedRoles,
      },
    })
    .state('search', {
      url: '/search?q',
      pageTitle: 'Search',
      template: STUB_TEMPLATE,
      data: {
        authorizedRoles: stubAuthorizedRoles,
      },
    })
    .state('admin', {
      url: '/admin/:section',
      pageTitle: 'Admin',
      template: STUB_TEMPLATE,
      data: {
        authorizedRoles: {
          [USER_ROLES.superUser]: {},
          [USER_ROLES.seniorImageEditor]: {},
        },
      },
    })
    .state('queue', {
      abstract: true,
      template: STUB_TEMPLATE,
    })
    .state('queue.qa', {
      url: '/queue/qa',
      pageTitle: 'Image QA',
      template: STUB_TEMPLATE,
      data: {
        authorizedRoles: {
          [USER_ROLES.qaReviewer]: {},
          [USER_ROLES.studioOps]: {},
          [USER_ROLES.superUser]: {},
        },
      },
    })
    .state('queue.post-prod', {
      url: '/queue/post-prod',
      pageTitle: 'Post Production',
      template: STUB_TEMPLATE,
      data: {
        authorizedRoles: {
          [USER_ROLES.digiTech]: {},
          [USER_ROLES.seniorImageEditor]: {},
          [USER_ROLES.imageEditor]: {},
          [USER_ROLES.externalImageEditor]: {},
          [USER_ROLES.photographer]: {},
          [USER_ROLES.studioOps]: {},
          [USER_ROLES.superUser]: {},
        },
      },
    })
    .state('detail', {
      url: '/detail/:productIdentifier/:jobId/:assetJobId/:tab',
      params: {
        jobId: null,
        assetJobId: null,
        tab: null,
        productIdentifierType: 'null',
      },
      pageTitle: 'Detail',
      template: STUB_TEMPLATE,
      data: {
        authorizedRoles: stubAuthorizedRoles,
        overlay: true,
      },
    })
    .state('qa', {
      url: '/qa/:id/:assetJobId?source&tab',
      pageTitle: 'QA Details',
      templateUrl: 'templates/views/qa.view.html',
      controllerAs: '$ctrl',
      controller: 'QaDetailController',
      data: {
        authorizedRoles: {
          [USER_ROLES.qaReviewer]: {},
          [USER_ROLES.studioOps]: {},
          [USER_ROLES.superUser]: {},
        },
        overlay: true,
      },
    });
};

module.exports = RouteConfig;
